class CustomVenueAPI {
  constructor() {
    this.baseURI = drupalSettings.path.baseUrl + drupalSettings.path.currentLanguage + '/thcb_venue_finder/';
  }

  callGetFilterApi(filterType, fieldName) {
    this.filterType = filterType;
    this.fieldName = fieldName;
    return fetch(this.baseURI + 'filter/' + this.filterType + '/' + this.fieldName, {credentials: "same-origin", method: 'GET'})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((results) => {return results})
      .catch(() => {console.log('There was an errror');});
  }

}

export default CustomVenueAPI;
